import React from "react";
import ReactApexChart from "react-apexcharts";
import { theme } from "antd";
import { useTranslation } from "react-i18next";

const LineChart = () => {
  const { t } = useTranslation("dashboard");
  const { token } = theme.useToken();
  const chartData = [
    { year: "2013", revenue: 60 },
    { year: "2014", revenue: 100 },
    { year: "2015", revenue: 240 },
    { year: "2016", revenue: 120 },
    { year: "2017", revenue: 80 },
    { year: "2018", revenue: 100 },
    { year: "2019", revenue: 300 }
  ];

  const series = [
    {
      name: t("Revenue"),
      data: chartData.map(data => data.revenue)
    }
  ];

  const chartOptions = {
    chart: {
      type: "area",
      stacked: false,
      toolbar: { show: false },
      fontFamily: token.fontFamily
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: chartData.map(data => data.year)
    },
    colors: [token.colorPrimary],
    stroke: {
      width: 2
    },
    fill: {
      opacity: 0.5
    },
    grid: {
      show: true,
      borderColor: token.colorBorderSecondary,
      strokeDashArray: 2
    },
    markers: {
      size: 3
    },
    tooltip: {
      theme: "dark"
    }
  };

  return <ReactApexChart options={chartOptions} series={series} type="area" height={280} />;
};

export default LineChart;
